<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
              <el-form-item label="逻辑删除" prop="deleted">
          <el-input v-model="dataForm.deleted" placeholder="逻辑删除"></el-input>
      </el-form-item>
          <el-form-item label="租户" prop="tenantId">
          <el-input v-model="dataForm.tenantId" placeholder="租户"></el-input>
      </el-form-item>
          <el-form-item label="出口发票号" prop="receiptCode">
          <el-input v-model="dataForm.receiptCode" placeholder="出口发票号"></el-input>
      </el-form-item>
          <el-form-item label="装船日期" prop="shipDate">
          <el-input v-model="dataForm.shipDate" placeholder="装船日期"></el-input>
      </el-form-item>
          <el-form-item label="产品ID" prop="productId">
          <el-input v-model="dataForm.productId" placeholder="产品ID"></el-input>
      </el-form-item>
          <el-form-item label="关联主表" prop="formId">
          <el-input v-model="dataForm.formId" placeholder="关联主表"></el-input>
      </el-form-item>
          <el-form-item label="合同id" prop="agreementId">
          <el-input v-model="dataForm.agreementId" placeholder="合同id"></el-input>
      </el-form-item>
          <el-form-item label="箱数" prop="boxCount">
          <el-input v-model="dataForm.boxCount" placeholder="箱数"></el-input>
      </el-form-item>
          <el-form-item label="入数" prop="preBoxCount">
          <el-input v-model="dataForm.preBoxCount" placeholder="入数"></el-input>
      </el-form-item>
          <el-form-item label="总数" prop="totalCount">
          <el-input v-model="dataForm.totalCount" placeholder="总数"></el-input>
      </el-form-item>
          <el-form-item label="总体积" prop="totalSize">
          <el-input v-model="dataForm.totalSize" placeholder="总体积"></el-input>
      </el-form-item>
          <el-form-item label="毛重" prop="weight">
          <el-input v-model="dataForm.weight" placeholder="毛重"></el-input>
      </el-form-item>
          <el-form-item label="单箱体积" prop="preSize">
          <el-input v-model="dataForm.preSize" placeholder="单箱体积"></el-input>
      </el-form-item>
          <el-form-item label="长" prop="boxLong">
          <el-input v-model="dataForm.boxLong" placeholder="长"></el-input>
      </el-form-item>
          <el-form-item label="宽" prop="boxWidth">
          <el-input v-model="dataForm.boxWidth" placeholder="宽"></el-input>
      </el-form-item>
          <el-form-item label="高" prop="boxHeight">
          <el-input v-model="dataForm.boxHeight" placeholder="高"></el-input>
      </el-form-item>
          <el-form-item label="工厂" prop="factoryId">
          <el-input v-model="dataForm.factoryId" placeholder="工厂"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      id:'',
      visible: false,
      dataForm: {
      id: '',
      creator: '',
      createDate: '',
      deleted: '',
      tenantId: '',
      receiptCode: '',
      shipDate: '',
      productId: '',
      formId: '',
      agreementId: '',
      boxCount: '',
      preBoxCount: '',
      totalCount: '',
      totalSize: '',
      weight: '',
      preSize: '',
      boxLong: '',
      boxWidth: '',
      boxHeight: '',
      factoryId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        deleted: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        tenantId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        receiptCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        shipDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        productId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        formId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        agreementId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        boxCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        preBoxCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        totalCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        totalSize: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        weight: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        preSize: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        boxLong: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        boxWidth: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        boxHeight: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],        factoryId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]      }
    }
  },
  methods: {
    reset(){
      this.dataForm={
                                                                deleted: '',                              tenantId: '',                              receiptCode: '',                              shipDate: '',                              productId: '',                              formId: '',                              agreementId: '',                              boxCount: '',                              preBoxCount: '',                              totalCount: '',                              totalSize: '',                              weight: '',                              preSize: '',                              boxLong: '',                              boxWidth: '',                              boxHeight: '',                              factoryId: ''                    }
      if(this.$refs['dataForm']){
        this.$refs['dataForm'].resetFields()
      }
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/trade/boxformdetail/${this.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm={
          ...this.dataForm
        }
        this.$http[!postForm.id ? 'post' : 'put']('/trade/boxformdetail/', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.cancel()
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    cancel(){
      this.visible = false
    }
  }
}
</script>
